/**
 * 活动主入口，主要做一些全局处理和设置，本JS一般不需要修改
 * 已自动加载jQuery、template模块，可直接使用$、template
 */
import 'babel-polyfill';

import checkSize from 'mihoyo-checksize'; // 老版checksize的优化版，请勿再手动引入checksize了
import mainView from './views/main'; // 视图主入口，它负责组织别的视图

import 'mihoyo-android-backkey-disable'; // 禁用安卓物理返回键，导致空白卡死的问题
import './lib';
import '../css/main'; // 活动样式，别的样式在main.css里面直接@import

// 根据当前环境选择性加载 mock 包，发布的时候也不用注释和删除
if(process.env.NODE_ENV === 'development') {
  require('./mock');
}

// FOR H5 屏幕尺寸处理
checkSize(Object.assign({
  // 宽高为设计稿宽高，必传
  widthParam: 1920,
  heightParam: 1080,
  forceVertical: true,
  //callback为checksize完成后的回调
  callback: () => {
    // frame 默认是hidden的，checksize完成后，再visible，避免页面checksize前后页面错位抖动
    document.getElementById('frame').style.visibility = 'visible';
  }
}));


mainView.render(); 
